import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { MentorQueuesData } from "../../types";
import { loadCompletedMentors } from "../../redux/actions/guideStreamActions";
import CompletedMentorsList from "./CompletedMentorsList";
import Loading from "../../../Shared/loading";
import useInterval from "../../../Shared/useInterval";

const mapState = ({ localizations, completedMentors, apiCallsInProgress }: MentorQueuesData) => ({
    completedMentors,
    localizations: localizations!,
    apiCallsInProgress,
});

const mapDispatch = {
    loadCompletedMentors,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

function CompletedPage({ completedMentors, loadCompletedMentors, localizations, apiCallsInProgress }: PropTypes) {
    useEffect(() => {
        if (completedMentors.length === 0) {
            loadCompletedMentors();
        }
    }, []);

    const [secondsUntilRefresh, updateSecondsUntilRefresh] = useState(30);

    useInterval(() => {
        if (secondsUntilRefresh === 0) {
            loadCompletedMentors();
            updateSecondsUntilRefresh(30);
        } else {
            updateSecondsUntilRefresh(secondsUntilRefresh - 1);
        }
    }, 1000);

    const refreshNow = () => {
        loadCompletedMentors();
        updateSecondsUntilRefresh(30);
    };

    return (
        <>
            {apiCallsInProgress > 0 ? (
                <>
                    <Loading message={localizations.loadingMentors} />
                </>
            ) : (
                <CompletedMentorsList
                    refreshNow={refreshNow}
                    refreshTimer={secondsUntilRefresh}
                    completedMentors={completedMentors}
                    localizations={localizations}
                />
            )}
        </>
    );
}

export default connector(CompletedPage);
